import { Spin } from 'antd';
import axios from 'axios';
import React, { useState } from 'react';
import config from '../../config';
import { notification } from 'antd';

const CheckDelivery = ({ all_category }) => {
  const [zipcode, setZipCode] = useState('');
  const [delivery, setDelivery] = useState(false);
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);

  const onCheckStatus = async (e) => {
    e.preventDefault();
    const postcode = zipcode.trim();
    const postcodeRegex = /^[A-Za-z0-9\s]{6,15}$/;

    // CRITICAL FIX: Explicit length validation check
    if (
      postcode.length < 6 ||
      postcode.length > 15 ||
      !postcodeRegex.test(postcode)
    ) {
      notification.error({
        message: 'Invalid Postcode',
        description:
          'Please enter a valid postcode between 6 and 15 characters. Only letters, numbers and spaces are allowed.',
      });
      return;
    }

    setLoader(true);
    const formData = new FormData();
    formData.append('category_id', all_category[0]?.id);
    formData.append('zipcode', postcode); // Use trimmed postcode variable

    const res = await axios({
      method: 'post',
      data: formData,
      url: `${config.apiUrl}/checkShippingCost`,
      headers: {
        Accept: 'application/json',
      },
    });

    setShow(true);
    setDelivery(res?.data !== 'N/A');
    setLoader(false);
    setZipCode('');

    setTimeout(() => {
      setShow(false);
    }, 4000);
  };

  return (
    <div className="mb-4">
      <form onSubmit={onCheckStatus}>
        <p
          className=" mb-3 text-black "
          style={{ color: 'black', fontSize: '16px' }}
        >
          Check Delivery Status
        </p>

        {show ? (
          <div
            className={`alert ${delivery ? 'alert-success' : 'alert-danger'}`}
            role="alert"
            style={{ fontSize: '13px' }}
          >
            {delivery
              ? 'Awesome! Delivery to your location is available! 🛒✨'
              : 'Oops! Delivery isn’t available for your location right now. 😢'}
          </div>
        ) : (
          <div className="ps-delivery-status ">
            <input
              className="coupon-field"
              type="text"
              placeholder="Enter postcode (6-15 chars)"
              value={zipcode}
              maxLength={15}
              onChange={(e) => {
                // 1. Strip out illegal characters
                let value = e.target.value.replace(/[^a-zA-Z0-9\s]/g, '');

                // 2. Convert to uppercase
                value = value.toUpperCase();

                // 3. CRITICAL: Hard slice at 15 characters to prevent state overflow
                if (value.length > 15) {
                  value = value.slice(0, 15);
                }

                setZipCode(value);
              }}
              required
            />
            <button type="submit">
              {loader ? <Spin className="check" /> : 'Check Now'}
            </button>
          </div>
        )}
      </form>

      <div className="mt-3" style={{ color: 'red' }}>
        Before making your purchase, kindly verify that delivery is available in
        your area.
      </div>
    </div>
  );
};

export default CheckDelivery;
